import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";
import ScrollToTop from "@/components/ScrollToTop";
import { Toaster } from "@/components/ui/toaster";
import { LanguageProvider } from "@/lib/LanguageContext";
import LangBar from "@/components/LangBar";

function App() {
  return (
    <Router>
      <LanguageProvider>
        <ScrollToTop />
        <div className="min-h-screen bg-gradient-to-b from-white to-[#f0ffff]">
          <LangBar />
          <Navbar />
          <Routes>
            {/* English Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            
            {/* Spanish Routes */}
            <Route path="/es" element={<Home />} />
            <Route path="/es/servicios" element={<Services />} />
            <Route path="/es/contacto" element={<Contact />} />
            <Route path="/es/privacidad" element={<Privacy />} />
            <Route path="/es/terminos" element={<Terms />} />
            
            {/* Fallback */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <Footer />
          <Toaster />
        </div>
      </LanguageProvider>
    </Router>
  );
}

export default App;
